import Accordion from "pages/Categories/components/Accordion";
import { useReportRecords } from "hooks/useReportRecords";
import { useParams } from "react-router-dom";
import DataLoaderOverlay from "components/DataLoaderOverlay";
import { useEffect, useState} from "react";
import Loader from "components/Loader";
import Summary from "./components/Summary";
import { useNavigate } from "react-router-dom";

const Categories = () => {
  const { id } = useParams();
  const { isLoading, reportData, fetchReportRecords, setSelectedCategory, fetchClientReport, fetchReportDownloadLink, deleteReport, generateReportNotes} =
    useReportRecords();
  const [reportDownloadLink, setReportDownloadLink] = useState("")
  const navigate = useNavigate();

  useEffect(() => {
    fetchReportRecords(id!);
    setSelectedCategory(undefined);

      const fetchDownloadLink = async () => {
        const link = await fetchReportDownloadLink(id!);
        setReportDownloadLink(link[0]['report_location_s3']);
      };
      fetchDownloadLink();

  }, [fetchReportRecords, id, setSelectedCategory, fetchReportDownloadLink]);

  const reportGenerate = async()=>{
    const url = await fetchClientReport(id!)
    window.open(url, "_blank");
  }

  const notesGenerate = async()=>{
    await generateReportNotes(id!)
  }

  const deleteThisReport = async(e:any)=>{
    await deleteReport(navigate,id!);
    e.preventDefault();
  }

  return (
    <DataLoaderOverlay isLoading={isLoading}>
      <div className="flex-col justify-center pt-14 bg-main">
        <div className="px-[40px] w-full">
          <a
            href="#"
            title="Generate Report"
            onClick={()=>{reportGenerate ()}}
            className="rounded-md px-[30px] text-xl bg-white float-right font-sans font-medium max-w-[250px] py-3"
          >Generate Report</a>
          <a
            href="#"
            title="Generate Notes"
            onClick={()=>{notesGenerate ()}}
            className="rounded-md px-[30px] text-xl bg-white float-right font-sans font-medium max-w-[250px] py-3 mx-3"
          >Generate Notes</a>
          {/* {reportDownloadLink! &&
            <a href={reportDownloadLink} target="_blank" className="rounded-md px-[30px] text-xl bg-white float-right font-sans font-medium max-w-[250px] py-3 mr-4">Download Report</a>
          } */}
        </div>
        <div className="px-[40px] w-full py-[64px] mt-5">
          {reportData ? <Accordion data={reportData} /> : <Loader />}
          {reportData ? <Summary /> : <Loader />}
        </div>
        <div className="px-[40px] w-full">
          <a
            href="#"
            title="Delete Report"
            onClick={(e)=>{deleteThisReport(e)}}
            className="rounded-md px-[30px] text-xl text-white bg-red-500 float-right font-sans font-medium max-w-[250px] py-3"
          >Delete Report</a>
        </div>
      </div>
    </DataLoaderOverlay>
  );
};

export default Categories;
